import { Item } from "../types";

type SavedListsType = {
  cocktails: Item[];
};

/** Pre-made lists that can be loaded on page load */
export const savedLists: SavedListsType = {
  cocktails: [
    { img: "https://static.ikenley.com/cocktails/1910.jpg", value: "1910" },
    {
      img: "https://static.ikenley.com/cocktails/a_to_b.jpg",
      value: "A To B",
    },
    {
      img: "https://static.ikenley.com/cocktails/alto_cucina.jpg",
      value: "Alto Cucina",
    },
    {
      img: "https://static.ikenley.com/cocktails/angel_face.jpg",
      value: "Angel Face",
    },
    {
      img: "https://static.ikenley.com/cocktails/bees_knees.jpg",
      value: "Bees Knees",
    },
    {
      img: "https://static.ikenley.com/cocktails/bennet.jpg",
      value: "Bennet",
    },
    {
      img: "https://static.ikenley.com/cocktails/benny_and_hot.jpg",
      value: "Benny And Hot",
    },
    {
      img: "https://static.ikenley.com/cocktails/between_the_sheets.jpg",
      value: "Between The Sheets",
    },
    { img: "https://static.ikenley.com/cocktails/bijou.jpg", value: "Bijou" },
    {
      img: "https://static.ikenley.com/cocktails/bobby_burns.jpg",
      value: "Bobby Burns",
    },
    {
      img: "https://static.ikenley.com/cocktails/boulevardier.jpg",
      value: "Boulevardier",
    },
    {
      img: "https://static.ikenley.com/cocktails/burnt_fuselage.jpg",
      value: "Burnt Fuselage",
    },
    {
      img: "https://static.ikenley.com/cocktails/casino.jpg",
      value: "Casino",
    },
    {
      img: "https://static.ikenley.com/cocktails/ce_soir.jpg",
      value: "Ce Soir",
    },
    {
      img: "https://static.ikenley.com/cocktails/champs-elysees.jpg",
      value: "Champs Elysees",
    },
    {
      img: "https://static.ikenley.com/cocktails/cock_n_bull_special.jpg",
      value: "Cock N Bull Special",
    },
    {
      img: "https://static.ikenley.com/cocktails/corpse_reviver_no_1.jpg",
      value: "Corpse Reviver No 1",
    },
    {
      img: "https://static.ikenley.com/cocktails/cynar_garita.jpg",
      value: "Cynar Garita",
    },
    {
      img: "https://static.ikenley.com/cocktails/daisy_de_santiago.jpg",
      value: "Daisy De Santiago",
    },
    { img: "https://static.ikenley.com/cocktails/derby.jpg", value: "Derby" },
    {
      img: "https://static.ikenley.com/cocktails/detroiter.jpg",
      value: "Detroiter",
    },
    {
      img: "https://static.ikenley.com/cocktails/dolly_zoom.jpg",
      value: "Dolly Zoom",
    },
    {
      img: "https://static.ikenley.com/cocktails/duplex.jpg",
      value: "Duplex",
    },
    {
      img: "https://static.ikenley.com/cocktails/el_camino.jpg",
      value: "El Camino",
    },
    {
      img: "https://static.ikenley.com/cocktails/elderflower_daquiri.jpg",
      value: "Elderflower Daquiri",
    },
    {
      img: "https://static.ikenley.com/cocktails/fancy_cocktail.jpg",
      value: "Fancy Cocktail",
    },
    {
      img: "https://static.ikenley.com/cocktails/fancy_free.jpg",
      value: "Fancy Free",
    },
    {
      img: "https://static.ikenley.com/cocktails/fine_and_dandy.jpg",
      value: "Fine And Dandy",
    },
    {
      img: "https://static.ikenley.com/cocktails/ford_cocktail.jpg",
      value: "Ford Cocktail",
    },
    {
      img: "https://static.ikenley.com/cocktails/frisco.jpg",
      value: "Frisco",
    },
    {
      img: "https://static.ikenley.com/cocktails/frisco_sour.jpg",
      value: "Frisco Sour",
    },
    {
      img: "https://static.ikenley.com/cocktails/gimlet.jpg",
      value: "Gimlet",
    },
    {
      img: "https://static.ikenley.com/cocktails/gold_rush.jpg",
      value: "Gold Rush",
    },
    {
      img: "https://static.ikenley.com/cocktails/harvest_sour.jpg",
      value: "Harvest Sour",
    },
    {
      img: "https://static.ikenley.com/cocktails/honey_apple_sour.jpg",
      value: "Honey Apple Sour",
    },
    {
      img: "https://static.ikenley.com/cocktails/honeysuckle.jpg",
      value: "Honeysuckle",
    },
    {
      img: "https://static.ikenley.com/cocktails/jack_rose.jpg",
      value: "Jack Rose",
    },
    {
      img: "https://static.ikenley.com/cocktails/kings_jubilee.jpg",
      value: "Kings Jubilee",
    },
    {
      img: "https://static.ikenley.com/cocktails/lani_honi.jpg",
      value: "Lani Honi",
    },
    {
      img: "https://static.ikenley.com/cocktails/le_tour.jpg",
      value: "Le Tour",
    },
    {
      img: "https://static.ikenley.com/cocktails/little_italy.jpg",
      value: "Little Italy",
    },
    {
      img: "https://static.ikenley.com/cocktails/man_o_war.jpg",
      value: "Man O War",
    },
    {
      img: "https://static.ikenley.com/cocktails/maximilian_affair.jpg",
      value: "Maximilian Affair",
    },
    {
      img: "https://static.ikenley.com/cocktails/mezcal_last_word.MP",
      value: "Mezcal Last Word",
    },
    {
      img: "https://static.ikenley.com/cocktails/mezcal_negroni.jpg",
      value: "Mezcal Negroni",
    },
    {
      img: "https://static.ikenley.com/cocktails/mickie_walker.jpg",
      value: "Mickie Walker",
    },
    {
      img: "https://static.ikenley.com/cocktails/monte_carlo.jpg",
      value: "Monte Carlo",
    },
    {
      img: "https://static.ikenley.com/cocktails/monte_cassino.jpg",
      value: "Monte Cassino",
    },
    {
      img: "https://static.ikenley.com/cocktails/nassau_street_cocktail.jpg",
      value: "Nassau Street Cocktail",
    },
    {
      img: "https://static.ikenley.com/cocktails/olivette.jpg",
      value: "Olivette",
    },
    {
      img: "https://static.ikenley.com/cocktails/one_chance_fancy.jpg",
      value: "One Chance Fancy",
    },
    {
      img: "https://static.ikenley.com/cocktails/pegu_club.jpg",
      value: "Pegu Club",
    },
    {
      img: "https://static.ikenley.com/cocktails/pendennis_club.jpg",
      value: "Pendennis Club",
    },
    {
      img: "https://static.ikenley.com/cocktails/pink_lady.jpg",
      value: "Pink Lady",
    },
    {
      img: "https://static.ikenley.com/cocktails/queen_bee.jpg",
      value: "Queen Bee",
    },
    {
      img: "https://static.ikenley.com/cocktails/queen_elizabeth.jpg",
      value: "Queen Elizabeth",
    },
    {
      img: "https://static.ikenley.com/cocktails/red_hook.jpg",
      value: "Red Hook",
    },
    { img: "https://static.ikenley.com/cocktails/ritz.jpg", value: "Ritz" },
    {
      img: "https://static.ikenley.com/cocktails/rum_old_fashioned.jpg",
      value: "Rum Old Fashioned",
    },
    {
      img: "https://static.ikenley.com/cocktails/saratoga.jpg",
      value: "Saratoga",
    },
    {
      img: "https://static.ikenley.com/cocktails/scofflaw.jpg",
      value: "Scofflaw",
    },
    {
      img: "https://static.ikenley.com/cocktails/sidecar.jpg",
      value: "Sidecar",
    },
    {
      img: "https://static.ikenley.com/cocktails/so_so_cocktail.jpg",
      value: "So So Cocktail",
    },
    {
      img: "https://static.ikenley.com/cocktails/souther_point.jpg",
      value: "Souther Point",
    },
    {
      img: "https://static.ikenley.com/cocktails/stan_lee.jpg",
      value: "Stan Lee",
    },
    {
      img: "https://static.ikenley.com/cocktails/stingless_bee.jpg",
      value: "Stingless Bee",
    },
    {
      img: "https://static.ikenley.com/cocktails/the_slope.jpg",
      value: "The Slope",
    },
    {
      img: "https://static.ikenley.com/cocktails/tight_five.jpg",
      value: "Tight Five",
    },
    {
      img: "https://static.ikenley.com/cocktails/tip_top.jpg",
      value: "Tip Top",
    },
    {
      img: "https://static.ikenley.com/cocktails/vancouver.jpg",
      value: "Vancouver",
    },
    {
      img: "https://static.ikenley.com/cocktails/vermoutharita.jpg",
      value: "Vermoutharita",
    },
    {
      img: "https://static.ikenley.com/cocktails/vieux_carre.jpg",
      value: "Vieux Carre",
    },
    {
      img: "https://static.ikenley.com/cocktails/ward_eight.jpg",
      value: "Ward Eight",
    },
    {
      img: "https://static.ikenley.com/cocktails/winter_daiquiri.jpg",
      value: "Winter Daiquiri",
    },
  ],
};

export default savedLists;
